import React, { useEffect } from 'react'
import servicestopshadow from "../../images/Blur.webp"
import "../services/services.css"
// import { ReactComponent as Scolimg1 } from "../../images/arserviceimg1.svg"
// import { ReactComponent as Scolimg2 } from "../../images/vrserviceimg.svg"
import { ReactComponent as Scolimg3 } from "../../images/aiserviceimg.svg"
import { ReactComponent as Scolimg4 } from "../../images/topenginersserviceimg.svg"


import arserviceimg from '../../images/arserviceimg1.jpg'
import vrserviceimg from '../../images/vrserviceimg.jpg'

import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles


function Services() {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    return (
        <section className='services' data-aos="fade-up">
            <img className='topshadow' src={servicestopshadow} alt="blurshadow" />
            <div className="title" data-aos="fade-up" data-aos-offset="200">
                <span>Services</span>
                <h1>How We Lead the Future</h1>
                <p>We’ve mastered the art of turning complex ideas into transformative solutions. With proven expertise in AR, VR, AI, and engineering, we’re trusted by top global brands to redefine what’s possible.</p>
            </div>
            <div className="services-inner">
                <div className="s-row" >
                    <a href="https://arttteo.com/services/augmented-reality">
                        <div className="s-col bigcol" data-aos="fade-up" data-aos-offset="300">
                            <div className="scol-h">
                                <div className="left">
                                    <h2>Augmented Reality</h2>
                                    <p>We craft AR solutions that wow audiences and drive business growth. From interactive retail to groundbreaking training experiences, our expertise knows no limits.</p>
                                </div>
                                <button></button>
                            </div>

                            <span className='scol-imageback' data-aos="fade-up"  >
                                <img src={arserviceimg} alt="ar service image" />
                            </span>
                        </div>
                    </a>
                    <a href="https://arttteo.com/services/virtual-reality">
                        <div className="s-col" data-aos="fade-up" data-aos-offset="300">
                            <div className="scol-h">
                                <div className="left">
                                    <h2>Virtual Reality</h2>
                                    <p>Create unforgettable virtual experiences that captivate, inspire, and redefine possibilities. Whether it's gaming, training, or events, we deliver cutting-edge VR for ambitious brands.</p>
                                </div>
                                <button></button>
                            </div>

                            <span className='scol-imageback' >
                                <img src={vrserviceimg} alt="vr service image" />
                            </span>
                        </div>
                    </a>
                </div>
                <div className="s-row">
                    <a href="https://arttteo.com/services/machine-learning">
                        <div className="s-col" data-aos="fade-up" data-aos-offset="300">
                            <div className="scol-h">
                                <div className="left">
                                    <h2>AI and Machine Learning</h2>
                                    <p>Harness the power of AI to predict, automate, and dominate your industry. From machine learning models to intelligent solutions, we empower you to lead the future.</p>
                                </div>
                                <button></button>
                            </div>

                            <span className='scol-imageback'>
                                <Scolimg3 />
                            </span>
                        </div>
                    </a>
                    <a href="https://arttteo.com/services/outsourcing">
                        <div className="s-col bigcol" data-aos="fade-up" data-aos-offset="300">
                            <div className="scol-h">
                                <div className="left">
                                    <h2>Dedicated Top Engineers</h2>
                                    <p>We provide the  top tech minds to turn your ideas into reality. Seamless collaboration, unmatched skills, and results-driven engineering – ready when you are.</p>
                                </div>
                                <button></button>
                            </div>

                            <span className='scol-imageback'>
                                <Scolimg4/>
                            </span>
                        </div>
                    </a>
                </div>

            </div>

        </section>
    )
}

export default Services